import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import {
  AlertModule,
  AmountModule,
  DropdownSingleSelectModule,
  EllipsisModule,
  IconModule,
  InputCheckboxModule,
  InputTextModule,
  InputValidationMessageModule,
  LoadingIndicatorModule,
  PaymentCardNumberModule,
  ProductItemBasicAccountModule,
  SearchBoxModule,
  TooltipModule,
  EmptyStateModule
} from '@backbase/ui-ang';
import { BnSemaphoreTooltipComponent } from './bn-semaphore-tooltip/bn-semaphore-tooltip.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskModule } from 'ngx-mask';
import { AccountSelectorComponent } from './bn-account-selector-ui/bn-account-selector.component';
import { BnAccountStatementListWidgetComponent } from './bn-account-statement-list-widget/bn-account-statement-list-widget.component';
import { BnAlertComponent } from './bn-alert/bn-alert.component';
import { BnAutoDecimalDirective } from './bn-auto-decimal-directive/bn-auto-decimal.directive';
import { BanescoCurrencySelectComponent } from './bn-currency-select/bn-currency-select.component';
import { BnCurrencySelectorCustomComponent } from './bn-currencySelectorCustom/bn-currencySelectorCustom.component';
import { BnHeadingUiComponent } from './bn-heading-ui/bn-heading-ui.component';
import { BnAccountNumberMaskDirective } from './bn-mask-directive/bn-account-no-mask.directive';
import { ProductItemBasicAccountComponent } from './bn-product-item-basic-account-ui/bn-account-item-basic-account.component';
import { BnContactBanescoFormComponent } from './contact-banesco-form/contact-banesco-form.component';
import { BnContactOtherFormComponent } from './contact-other-form/contact-other-form.component';
import { BnCCFormatPipe } from './pipes/bn-credit-card-format/bn-credit-card-format';
import { BnCurrencyPipe } from './pipes/bn-currency-pipe/bn-currency.pipe';
import { BnDigitPipe } from './pipes/bn-digit-pipe/bn-digit.pipe';
import { MaskAccountPipe } from './pipes/mask-account/mask-account.pipe';
import { BnReplacePipe } from './pipes/bn-replace/bn-replace.pipe';
import { BnEsDatePipe } from './pipes/bn-es-date-pipe/bn-es-date.pipe';
import { BnEmptyPipe } from './pipes/bn-empty-pipe/bn-empty.pipe';

@NgModule({
  imports: [
    CommonModule,
    IconModule,
    AlertModule,
    FormsModule,
    ReactiveFormsModule,
    InputValidationMessageModule,
    DropdownSingleSelectModule,
    InputTextModule,
    LoadingIndicatorModule,
    ProductItemBasicAccountModule,
    NgSelectModule,
    SearchBoxModule,
    InputCheckboxModule,
    EllipsisModule,
    PaymentCardNumberModule,
    AmountModule,
    TooltipModule,
    NgxMaskModule.forRoot()
  ],
  declarations: [
    AccountSelectorComponent,
    BnAccountStatementListWidgetComponent,
    BnAlertComponent,
    BnAutoDecimalDirective,
    BanescoCurrencySelectComponent,
    BnCurrencySelectorCustomComponent,
    BnHeadingUiComponent,
    BnAccountNumberMaskDirective,
    ProductItemBasicAccountComponent,
    BnSemaphoreTooltipComponent,
    BnContactBanescoFormComponent,
    BnContactOtherFormComponent,

    //PIPES
    BnCCFormatPipe,
    BnCurrencyPipe,
    BnDigitPipe,
    BnEmptyPipe,
    BnEsDatePipe,
    BnReplacePipe,
    MaskAccountPipe
  ],
  exports: [
    AccountSelectorComponent,
    BnAccountStatementListWidgetComponent,
    BnAlertComponent,
    BnAutoDecimalDirective,
    BanescoCurrencySelectComponent,
    BnCurrencySelectorCustomComponent,
    BnHeadingUiComponent,
    BnAccountNumberMaskDirective,
    ProductItemBasicAccountComponent,
    BnSemaphoreTooltipComponent,
    BnContactBanescoFormComponent,
    BnContactOtherFormComponent
  ],
  providers: [
    BnCCFormatPipe,
    BnCurrencyPipe,
    BnDigitPipe,
    BnEmptyPipe,
    BnEsDatePipe,
    BnReplacePipe,
    MaskAccountPipe
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class UIComponentModule {}
